import styled from "styled-components";

export const BgHeader = styled.section`
  background-repeat: no-repeat;
  background-size: cover;
  background: ${(props) =>
    props.color >= 0 && props.color <= 20
      ? `linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(64,201,85,1) 100%)`
      : props.color >= 21 && props.color <= 40
      ? `linear-gradient(0deg, rgba(255,255,255,1) 0%, #A4D634 100%)`
      : props.color >= 41 && props.color <= 60
      ? `linear-gradient(180deg,#FEE114 0%,rgba(255,255,255,1) 100%)`
      : props.color >= 61 && props.color <= 80
      ? `linear-gradient(180deg,#F5A120 0%,rgba(255,255,255,1) 100%)`
      : props.color >= 81 && props.color <= 100
      ? `linear-gradient(180deg,#E63832 0%,rgba(255,255,255,1) 100%)`
      : "linear-gradient(180deg,#16a34a99 0%,rgba(255,255,255,1) 100%)"};

  padding: 140px 0px 200px;
  margin-top: 0px;
`;
export const ResultCardAction = styled.div`
  border: 3px solid
    ${(props) =>
      props.color >= 0 && props.color <= 20
        ? "#16a34a99 "
        : props.color >= 21 && props.color <= 40
        ? "#A4D63499"
        : props.color >= 41 && props.color <= 60
        ? "#FEE11499 "
        : props.color >= 61 && props.color <= 80
        ? "#F5A12099"
        : props.color >= 81 && props.color <= 100
        ? "#E6383299 "
        : ""};
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 8px;
`;

export const nav = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  background: ${(props) =>
    props.color >= 0 && props.color <= 20
      ? ` #40C955 `
      : props.color >= 21 && props.color <= 40
      ? ` #A4D634`
      : props.color >= 41 && props.color <= 60
      ? `#FEE114`
      : props.color >= 61 && props.color <= 80
      ? `#F5A120 `
      : props.color >= 81 && props.color <= 100
      ? `#E63832 `
      : "#16a34a99"};
  margin: 0px !important;
`;
export const BtnWrapperHead = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin: 10px 0px;
  padding: 12px 6px;
  font-size: 12px;
  width: 100%;
  border-radius: 10px;
  background: ${(props) =>
    props.color >= 0 && props.color <= 20
      ? "#16a34a99 "
      : props.color >= 21 && props.color <= 40
      ? "#A4D63499"
      : props.color >= 41 && props.color <= 60
      ? "#FEE11499 "
      : props.color >= 61 && props.color <= 80
      ? "#F5A12099"
      : props.color >= 81 && props.color <= 100
      ? "#E6383299 "
      : "#16a34a99"};
`;

export const Container = styled.div`
  background-color: #fff;
  border-radius: 16px 16px 0px 0px;
  margin-top: -300px;
  padding: 20px 24px;
  margin-bottom: 20px;
`;
export const Degree = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
export const DegreeSvg = styled.svg``;

export const Hand = styled.div`
  position: absolute;
  transform: ${(props) =>
    props.rang <= 5
      ? "rotate(25deg) "
      : props.rang >= 5 && props.rang <= 10 && !props.rang <= 20
      ? "rotate(-5deg) "
      : props.rang >= 10 && props.rang <= 20 && !props.rang <= 30
      ? "rotate(-45deg) "
      : props.rang >= 20 && props.rang <= 30 && !props.rang <= 40
      ? "rotate(-80deg) "
      : props.rang <= 31
      ? "rotate(-120deg) "
      : ""};
`;

export const GaugeComponent = styled.div`
  margin-top: -65px;
  width: 250px;
  z-index: 200;
  position: absolute;
  background: radial-gradient(
    circle at bottom,
    rgba(255, 255, 255, 1) 65%,
    rgb(0 0 0 / 0%) 66%
  );
`;

export const ResultHealth = styled.div`
  border-radius: 10px;
  margin-top: 60px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px 0px;
  background: ${(props) =>
    props.color >= 0 && props.color <= 20
      ? "#16a34a99 "
      : props.color >= 21 && props.color <= 40
      ? "#A4D63499"
      : props.color >= 41 && props.color <= 60
      ? "#FEE11499 "
      : props.color >= 61 && props.color <= 80
      ? "#F5A12099"
      : props.color >= 81 && props.color <= 100
      ? "#E6383299 "
      : "#16a34a99"};
`;

export const ResultHealthTitle = styled.p`
  color: #2a3e64;
  font-size: 12px;
  font-weight: 400;
  line-height: 36px;
`;

export const ResultHealthRenge = styled.p`
  color: ${(props) =>
    props.color >= 0 && props.color <= 20
      ? "#14532d "
      : props.color >= 21 && props.color <= 40
      ? "#3f6212"
      : props.color >= 41 && props.color <= 60
      ? "#854d0e "
      : props.color >= 61 && props.color <= 80
      ? "#F5A120"
      : props.color >= 81 && props.color <= 100
      ? "#7f1d1d "
      : "#16a34a99"};
  font-size: 24px;
  font-weight: 900;
  line-height: 36px;
  margin-top: 10px;
`;

export const ResultSummary = styled.div`
  border-radius: 10px;
  background: rgba(68, 149, 178, 0.1);
  margin-top: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px 0px;
`;

export const ResultSummaryText = styled.p`
  color: #4495b2;
  font-size: 11px;
  font-weight: 300;
  padding: 10px 10px 0px;
  margin-bottom: 0px !important;
`;

export const Summary = styled.div``;

export const SummaryTitle = styled.p`
  margin: 16px 0px 8px;
  color: #4495b2;
  font-size: 16px;
  font-weight: 700;
`;

export const SummaryText = styled.p`
  color: #2a3e64;
  font-size: 12px;
  font-weight: 700;
`;

export const Actions = styled.div``;

export const ActionsTitle = styled.p`
  margin: 16px 0px 8px;
  color: #4495b2;
  font-size: 16px;
  font-weight: 700;
`;
export const ActionsCard = styled.div`
  border: 1px solid #d8e1ea;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 8px;
`;

export const CardTitle = styled.p`
  color: #2a3e64;
  font-size: 14px;
  font-weight: 500;
  line-height: 180%;
`;
export const BtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin: 6px 0px;
`;
export const BtnAdd = styled.button`
  border-radius: 10px;
  background: #eaf9f8;
  color: #4495b2;
  border: none;
  padding: 6px 12px;
`;

export const BtnCounseling = styled.button`
  border-radius: 10px;
  background: var(
    --linear,
    linear-gradient(164deg, #5ed2d2 0%, #5ed2b7 58.45%)
  );
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
  color: #fff;
  border: none;
  padding: 6px 12px;
`;
export const CalorieCard = styled.div`
  margin-top: 10px;
  border: 1px solid #d8e1ea;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 8px;
  background-color: ${(props) => (props.bg ? " #5ed2b7" : "#eaf9f8")};
  color: ${(props) => (props.bg ? " #fff" : "#4495b2")};
  font-weight: ${(props) => (props.bg ? " 600" : "400")};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TextTable = styled.span`
  font-size: 12px;
  text-align: center;
`;
